import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { useThemeValue } from '../../state/theme';
import { Flex } from '../Flex';
/**
 * Renders the main header bar of the application
 */
export const HeaderBar = (props) => {
    const { children } = props;
    const backgroundClass = useThemeValue('aside-background', 'bg-appBackground');
    const textClass = useThemeValue('aside-text', 'text-white');
    return (_jsx(Flex, Object.assign({ tag: "header", justifyContent: "between", alignItems: "center", className: clsx('px-4 py-3 fixed top-0 left-0 right-0 h-16 z-10 shadow-md', backgroundClass, textClass) }, { children: children }), void 0));
};
//# sourceMappingURL=HeaderBar.js.map